<template>
  <div class="nx-central-newsroom-distributed-contents">
    <nx-relation-editor-toolbar :title="label"></nx-relation-editor-toolbar>
    <div class="nx-central-newsroom-distributed-contents__list pa-2">
      <nx-list
        v-if="value.length"
        :items="formattedItems"
        normal
        selectable
        @click:item="onClick"
      />
      <div class="nx-relation-group-card mb-3 nx-primary--lighten-5 empty" v-else>
        <v-layout column class="pt-2 empty justify-center align-center">
          <span class="d-block caption nx-heading--level-4 mt-1" v-html="translations.empty"></span>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import NxRelationEditorToolbar from '@/modules/relation/editor/components/Toolbar';
import NxList from '@/components/list/List';
import { makeFormatter } from '@/modules/list/config';
import { entityEditorRoute } from '@/modules/entity/router';

export default {
  name: 'nx-central-newsroom-distributed-content',

  components: {
    NxRelationEditorToolbar,
    NxList,
  },

  props: {
    value: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    label: {
      type: String,
      required: false,
      default: 'contentDistributionSource',
    },
    name: {
      type: String,
      required: false,
      default: 'contentDistributionSource',
    },
  },
  computed: {
    translations() {
      console.log(this.name);
      return {
        empty: this.$te(`message.form.fields.${this.name}Empty`)
          ? this.$t(`message.form.fields.${this.name}Empty`)
          : 'Sin contenidos',
      };
    },
    formattedItems() {
      // https://github.com/vuejs/vue/issues/2000#issuecomment-527146280
      return Object.freeze(
        this.value.map(item => ({
          siteId: item.siteId,
          ...(item.list ? item.list : makeFormatter(this.entity)(item)),
        })),
      );
    },
  },
  methods: {
    onClick(item) {
      const content = this.value.find(c => c.id === item.id);
      if (!content || !content.type) return;

      const { href } = this.$router.resolve(entityEditorRoute.get(content.type, content));
      if (href) {
        window.open(href, '_blank');
      }
    },
  },
};
</script>

<style lang="stylus">
.nx-central-newsroom-distributed-contents {
  &__list {
    background-color: #F7F7FA;
  }
}
</style>
